// removed by extract-text-webpack-plugin
module.exports = {"container-outer":"src-modules-app-__AuthLayout__container-outer--2Ta5B","container-inner":"src-modules-app-__AuthLayout__container-inner--3IQnq","box":"src-modules-app-__AuthLayout__box--1tOZc","box-title":"src-modules-app-__AuthLayout__box-title--UsAiS","box-content":"src-modules-app-__AuthLayout__box-content--1_pA0"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/app/AuthLayout.less
// module id = 1877
// module chunks = 0